export var DECLARE_RESOURCES = 'AOR/DECLARE_RESOURCES';
export var declareResources = function declareResources(resources) {
  return {
    type: DECLARE_RESOURCES,
    payload: resources
  };
};